import { render, staticRenderFns } from "./bgmTable.vue?vue&type=template&id=47f68590"
import script from "./bgmTable.vue?vue&type=script&lang=js"
export * from "./bgmTable.vue?vue&type=script&lang=js"
import style0 from "./bgmTable.vue?vue&type=style&index=0&id=47f68590&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports